import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import logo from '~/assets/images/loGo.png';
import logoFLIC from '~/assets/images/Logo_flic.png';

const Header = () => {
    const navItems = [
        {
            name: "Giới thiệu",
            url: null,
            subNav: [
                { name: "Đề án tổ chức thi", url: "/exam-project", target: "_self" },
                { name: "Quy trình, thủ tục thi", url: "/exam-procedure", target: "_self" },
                { name: "Định dạng đề thi", url: "/exam-format", target: "_self" }
            ]
        },
        {
            name: "Thi UDCNTT",
            url: null,
            subNav: [
                { name: "Thông báo thi", url: "/exam-notice", target: "_self" },
                { name: "Hướng dẫn đăng ký thi", url: "/exam-instruction", target: "_self" },
                { name: "Kế hoạch thi", url: "/exam-plan", target: "_self" },
            ]
        },
        {
            name: "Thư viện",
            url: null,
            subNav: [
                { name: "Biểu mẫu", url: "/form-template", target: "_self" },
                { name: "Tài liệu tham khảo", url: "/refer-document", target: "_self" },
                { name: "Văn bản pháp quy", url: "/legal-text", target: "_self" }
            ]
        },
        {
            name: "Tra cứu",
            url: null,
            subNav: [
                { name: "Thông tin thí sinh", url: "/infor-student", target: "_self" },
                { name: "Tra cứu kết quả thi", url: "https://nnth.dthu.edu.vn/Thongtin_Tonghop.aspx", target: "_blank" },
                { name: "Tra cứu chứng chỉ", url: "https://nnth.dthu.edu.vn/tracuu_cccn.aspx", target: "_blank" }
            ]
        },
        {
            name: "Liên hệ",
            url: '/contact'
        }
    ];

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    return (
        <>
            <Box sx={{ backgroundColor: 'var(--blue)', color: '#FFFFFF', p: 2 }}>
                <Typography sx={{ fontWeight: "bold", maxWidth: 'lg', margin: 'auto', textAlign: 'center', fontSize: { md: 18, xs: 14 } }}>
                    HỆ THỐNG ĐĂNG KÝ THI CHỨNG CHỈ ỨNG DỤNG CNTT TẠI TRƯỜNG ĐẠI HỌC ĐỒNG THÁP
                </Typography>
            </Box>
            <Box
                sx={{
                    display: "flex", alignItems: 'center', justifyContent: 'space-between',
                    minHeight: '50px', maxWidth: 'lg', marginInline: 'auto', mt: 1, paddingInline: 2,
                }}>
                <Link to="/home" underline="none">
                    <Box sx={{ display: "flex", alignItems: 'center' }}>
                        <Box sx={{ width: { md: 80, sm: 150 } }}>
                            <img className='img-cover' src={logo} alt="Logo" />
                        </Box>
                        <Box sx={{ width: 250, ml: 2, display: { xs: "none", md: "flex" } }}>
                            <img className='img-cover' src={logoFLIC} alt="Logo" />
                        </Box>
                    </Box>
                </Link>


                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="end"
                    onClick={handleDrawerToggle}
                    sx={{ display: { sm: "none" } }}
                >
                    <MenuIcon sx={{ width: 40, height: 40, color: "var(--primary)" }} />
                </IconButton>

                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: "80%" },
                    }}
                >
                    <Box sx={{ p: 2, paddingBottom: 4 }}>
                        <Box >
                            <img className='img-cover' src={logoFLIC} alt="Logo" />
                        </Box>
                        <Divider sx={{ marginBlock: 2 }} />
                        <Box
                            sx={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                                textAlign: 'center', mt: 4
                            }}>
                            {navItems.map((nav, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        fontWeight: "bold",
                                        fontSize: 16,
                                        textTransform: "uppercase",
                                        color: "var(--primary)",
                                        cursor: 'pointer',
                                        ":hover": { color: "var(--blue)" }
                                    }}

                                    className="mobile-menu-primary"
                                    onClick={(e) => {
                                        let el = e.target.closest(".mobile-menu-primary");
                                        let elSub = document.querySelector(".open");
                                        if (elSub) {
                                            elSub.classList.remove("open");
                                        }

                                        if (el && el !== elSub) {
                                            el.classList.toggle("open");
                                        }
                                    }}
                                >
                                    {nav.url ? (
                                        <Link to={nav.url} style={{ color: 'inherit', textDecoration: 'none' }}>
                                            {nav.name}
                                        </Link>
                                    ) : (
                                        <Box>{nav.name}</Box>
                                    )}

                                    {nav.subNav && (
                                        <Box
                                            sx={{
                                                display: 'none'

                                            }}
                                            className="mobile-submenu"
                                        >
                                            <Divider sx={{ marginBlock: 2 }} />

                                            {nav.subNav.map((sub, subIndex) => (
                                                <Link
                                                    key={subIndex}
                                                    to={sub.url}
                                                    style={{
                                                        display: 'block',
                                                        textDecoration: 'none',
                                                        textWrap: 'nowrap',
                                                        color: 'var(--primary)',
                                                        fontSize: 16,
                                                        padding: 12,
                                                    }}
                                                    className="link-blue"
                                                    target={sub.target}
                                                    onClick={handleDrawerToggle}
                                                >
                                                    {sub.name}
                                                </Link>
                                            ))}
                                            <Divider sx={{ mt: 2 }} />

                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Box>

                </Drawer>
                <Box sx={{ display: { xs: "none", sm: "flex" } }}>
                    {navItems.map((nav, index) => (
                        <Box
                            key={index}
                            sx={{
                                position: 'relative',
                                fontWeight: "bold",
                                fontSize: 16,
                                textTransform: "uppercase",
                                ml: 2,
                                p: { sm: 1, md: 2 },
                                color: "var(--primary)",
                                cursor: 'pointer',
                                ":hover": { color: "var(--blue)", backgroundColor: "transparent" }
                            }}
                            className="menu-primary"
                        >
                            {nav.url ? (
                                <Link to={nav.url} style={{ color: 'inherit', textDecoration: 'none' }}>
                                    {nav.name}
                                </Link>
                            ) : (
                                <Box>{nav.name}</Box>
                            )}

                            {nav.subNav && (
                                <Box
                                    sx={{
                                        display: 'none',
                                        position: 'absolute',
                                        top: '90%',
                                        left: 0,
                                        backgroundColor: '#FFFFFF',
                                        boxShadow: '0px 4px 8px 2px rgba(0,0,0,0.1)',
                                        zIndex: 10,
                                        minWidth: '200px',
                                        p: 1,
                                        borderRadius: '4px',

                                    }}
                                    className="submenu"
                                >
                                    {nav.subNav.map((sub, subIndex) => (
                                        <Link
                                            key={subIndex}
                                            to={sub.url}
                                            style={{
                                                display: 'block',
                                                textDecoration: 'none',
                                                textWrap: 'nowrap',
                                                color: 'var(--primary)',
                                                fontSize: 16,
                                                padding: 8,
                                            }}
                                            className="link-blue"
                                            target={sub.target}
                                        >
                                            {sub.name}
                                        </Link>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>

            <style>
                {`
                    .submenu {
                        display: none;
                    }
                    .menu-primary:hover .submenu {
                        display: block;
                    }
                    .mobile-menu-primary.open .mobile-submenu {
                        display: block;
                    }
                `}
            </style>
        </>
    );
};

export default Header;
